import { render, staticRenderFns } from "./MbOverlay.vue?vue&type=template&id=5ebd5abb"
import script from "./MbOverlay.vue?vue&type=script&lang=js"
export * from "./MbOverlay.vue?vue&type=script&lang=js"
import style0 from "./MbOverlay.vue?vue&type=style&index=0&id=5ebd5abb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports